var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-crypto-icons"},[_c('img',{staticClass:"c-coinInfo__icon",style:({width:_vm.size+'px',height:_vm.size+'px'}),attrs:{"src":_vm.icon,"alt":_vm.symbol}})])
}
var staticRenderFns = []

export { render, staticRenderFns }